import React, { Component, useEffect, useState } from 'react'
import axios from 'axios';
import { API } from '../../../config/API';
import Loader from '../../../components/Loader/Loader';
import './Overview.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faBullhorn, faGraduationCap, faBookOpen, faUser, faBuilding } from '@fortawesome/free-solid-svg-icons';
import { departments } from '../../../config/Department';
import { GoOrganization } from "react-icons/go";


const Overview = () => {

  const [loader, setLoader] = useState(false);
  const [userData, setUserData] = useState(null);

  useEffect(() => {
    const storedUserData = sessionStorage.getItem("userData");
    if (storedUserData) {
      setUserData(JSON.parse(storedUserData));
    }
  }, []);

  return (
    <div>
      <Loader loading={loader}></Loader>
      <div className='bread-crumb overflow-auto'>
        <div>
          <span className='breadcrumb-title'>
            <input type='button' className='btn' value='Home'></input>
          </span>

        </div>
      </div>
      <div className='mt-4 mb-4'>
        <div className='row m-auto sa-overview'>
          <div className="card col-md-6" >
            <div className="card-body assessment-box">
              <h4 className="card-title  ">
                <span><GoOrganization /></span>
                Organisation Details
              </h4>
              {/* <p className="card-text ">{this.serverData.assessments.totalNo}</p> */}
              <div className='card-detail-block-sa'>
                {userData ? (
                  <>
                    <p><strong>Organisation Name:</strong> {userData.organisationName}</p>
                    <p><strong>Unique Code:</strong> {userData.uniqueCode}</p>
                    <p><strong>User Name:</strong> {userData.username}</p>
                    <p><strong>Email:</strong> {userData.email}</p>
                  </>
                ) : (
                  <p>Loading...</p>
                )}
                
              </div>
              {/* <a href="#" className="btn btn-primary">Go somewhere</a> */}
            </div>
          </div>
          {/* <div className="card col-md-6" >
            <div className="card-body training-box">
              <h4 className="card-title  ">
                <span><FontAwesomeIcon icon={faBookOpen} /></span>TRAINING</h4>
              <div className='card-detail-block-admin'>
                test
              </div>
            </div>
          </div> */}
        </div>
      </div>

      {/* <div className='mt-4 mb-5'>
          <div className='row m-auto admin-overview'>
            <div className="card col-md-6" >
              <div className="card-body communication-box">
                <h4 className="card-title  ">
                  <span><FontAwesomeIcon icon={faBullhorn} /></span>COMMUNICATION</h4>
                <div className='card-detail-block-admin'>
                  test
                </div>
              </div>
            </div>
            <div className="card col-md-6" >
              <div className="card-body user-stat-box">
                <div className='card-detail-block-user-admin'>
                  <div className='user-sect'>
                    <h3> <span><FontAwesomeIcon icon={faUser} /></span>Users</h3>
                  </div>
                  <div className='user-sect'>
                    test
                  </div>

                </div>
              </div>
            </div>
          </div>
        </div> */}

    </div>
  )
}

export default Overview;